import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import { jsx as _jsx } from "react/jsx-runtime";
import { Box, Tooltip } from "@components/mantine";
import { PrivilegeUtils } from "@core/user";
import { AttentionSize16Px, CircleArrowBottomSize16Px } from "@coveord/plasma-react-icons";
import { Locales } from "../../strings/Locales.js";
import { PrivilegesTableUtils } from "./PrivilegesTableUtils.js";
import { usePrivilegeRow } from "./PrivilegeTableContext.js";
var privilegeWarningIconMapping = {
    REDUCTION: CircleArrowBottomSize16Px,
    LOCKOUT: AttentionSize16Px,
    POTENT: AttentionSize16Px
};
var ref;
var PrivilegesTableWarning = function(param) {
    var type = param.type, affectedPrivileges = param.affectedPrivileges;
    /*#__PURE__*/ return _jsx(Tooltip, {
        label: Locales.format("PrivilegesTable.warning.tooltip.".concat(type), {
            formattedPrivilegesPassive: PrivilegeUtils.toSentence(affectedPrivileges),
            formattedPrivilegesActive: PrivilegeUtils.toSentence(affectedPrivileges, true),
            smart_count: (ref = affectedPrivileges === null || affectedPrivileges === void 0 ? void 0 : affectedPrivileges.length) !== null && ref !== void 0 ? ref : 0
        }),
        children: /*#__PURE__*/ _jsx(Box, {
            ml: "xs",
            c: "warning",
            component: privilegeWarningIconMapping[type],
            height: 16
        })
    });
};
export var PrivilegesTableWarnings = function(row) {
    var ref = usePrivilegeRow(row.id), selectedPrivileges = ref.selectedPrivileges, readOnly = ref.readOnly;
    if (readOnly) {
        return null;
    }
    var warnings = PrivilegesTableUtils.getWarnings({
        selectedPrivileges: selectedPrivileges,
        initialPrivileges: row.initialPrivileges,
        availablePrivileges: row.availablePrivileges,
        exclusivePrivileges: row.exclusivePrivileges
    });
    return warnings.map(function(warning) {
        return /*#__PURE__*/ _jsx(PrivilegesTableWarning, _object_spread({}, warning), warning.type);
    });
};

//# sourceMappingURL=PrivilegesTableWarnings.js.map